import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=d1097e9e&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=d1097e9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1097e9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1097e9e')) {
      api.createRecord('d1097e9e', component.options)
    } else {
      api.reload('d1097e9e', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=d1097e9e&scoped=true&", function () {
      api.rerender('d1097e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2B6pihqP2K7c4/JS/comp/GuestBox.vue"
export default component.exports